import React from "react";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";

export const headCells = ["id", "Subdomain", "Login Url"];

export const EntrataUsersTableHead = () => (
  <TableHead>
    <TableRow>
      {headCells.map((cell) => (
        <TableCell key={cell} align="justify">
          {cell}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);
